import React from 'react';
import EventDetail from 'containers/eventDetail/eventDetailContainer';

const EventDetailPage = () => {
	return <EventDetail />;
};

export default EventDetailPage;
